import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row lockHeader shinseisyoHeader" }
const _hoisted_2 = { class: "subheader col-md-6" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-dark fw-400 l-h-n"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-warning fw-400 l-h-n"
}
const _hoisted_6 = {
  key: 2,
  class: "badge badge-info fw-400 l-h-n"
}
const _hoisted_7 = {
  key: 3,
  class: "badge badge-success fw-400 l-h-n"
}
const _hoisted_8 = {
  key: 4,
  class: "badge badge-danger fw-400 l-h-n"
}
const _hoisted_9 = {
  class: "subheader-block ml-auto demo col-md-6",
  style: {"text-align":"right"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_21 = { class: "d-flex flex-start w-100" }
const _hoisted_22 = { class: "d-flex flex-fill" }
const _hoisted_23 = { class: "flex-fill" }
const _hoisted_24 = { class: "m-0" }
const _hoisted_25 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_26 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_27 = {
  key: 3,
  class: "alert alert-primary"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-xl-12" }
const _hoisted_30 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_31 = { class: "panel-container show" }
const _hoisted_32 = { class: "panel-content contents" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-5 contCnt" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-5 contCnt" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-5 contCnt" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-5 contCnt" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-5 contCnt" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-5 contCnt" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-5 contCnt" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-5 contCnt" }
const _hoisted_51 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_52 = { class: "col-md-5 contCnt" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-5 contCnt" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-5 contCnt" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-5 contCnt" }
const _hoisted_61 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-5 contCnt" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-md-5 contCnt" }
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "col-md-5 contCnt" }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-5 contCnt" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-md-5 contCnt" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col-md-5 contCnt" }
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-md-5 contCnt" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-5 contCnt" }
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "col-md-5 contCnt" }
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-md-5 contCnt" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-md-7 contCnt" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "col contCnt" }
const _hoisted_90 = {
  class: "demo",
  style: {"overflow":"auto"}
}
const _hoisted_91 = { class: "bg-primary-400" }
const _hoisted_92 = { class: "keihiCont" }
const _hoisted_93 = { id: "header4Recept" }
const _hoisted_94 = { style: {"width":"230px","position":"absolute","right":"60px","top":"15px"} }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = {
  id: "body4Recept",
  class: "panel-container"
}
const _hoisted_98 = {
  key: 0,
  id: "dzFlame",
  style: {"width":"100%","height":"150px","background-color":"white"}
}
const _hoisted_99 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_100 = { class: "col-md-12 contTitle" }
const _hoisted_101 = {
  id: "frame-img",
  style: {"box-shadow":"0 0 0.5cm rgba(0, 0, 0, 0.5)","margin":"0 auto","width":"90%","margin-top":"20px","overflow":"hidden"}
}
const _hoisted_102 = {
  key: 1,
  id: "frame-img4None",
  style: {"display":"flex","justify-content":"center","align-items":"center","max-width":"400px","width":"90%","min-height":"420px","margin":"0 auto"}
}
const _hoisted_103 = {
  key: 0,
  style: {"text-align":"center","color":"#3b31a1"},
  class: "h2"
}
const _hoisted_104 = {
  key: 1,
  style: {"text-align":"center","color":"#3b31a1"},
  class: "h2"
}
const _hoisted_105 = {
  id: "footer4Recept",
  class: "modal-footer"
}
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "text-success fw-500" }
const _hoisted_108 = { class: "modal-footer" }
const _hoisted_109 = { class: "modal-footer" }
const _hoisted_110 = { class: "modal-footer" }
const _hoisted_111 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_CurrencyInput = _resolveComponent("Mo_CurrencyInput")!
  const _component_Mo_expenses_row = _resolveComponent("Mo_expenses_row")!
  const _component_dropzone = _resolveComponent("dropzone")!
  const _component_Or_pdfviewer = _resolveComponent("Or_pdfviewer")!
  const _component_Mo_modal_right_l = _resolveComponent("Mo_modal_right_l")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _cache[35] || (_cache[35] = _createTextVNode(" 経費精算書 ")),
          (_ctx.delegate.request.c_request_status == 4)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_4, "取下"))
            : _createCommentVNode("", true),
          (
              _ctx.delegate.request.c_request_status == 0 ||
              _ctx.delegate.request.c_request_status == 5
            )
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "未申請"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 1)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "申請中"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 3)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "承認済"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 2)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_8, "差戻"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.delegate.c_request_expenses_id != null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.rewriteFlg)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    disabled: _ctx.btnDisable,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reriteConf()))
                  }, _cache[36] || (_cache[36] = [
                    _createElementVNode("span", { class: "fal fa-undo-alt mr-1" }, null, -1),
                    _createTextVNode("再編集 ")
                  ]), 8, _hoisted_10))
                : _createCommentVNode("", true),
              (
              _ctx.delegate.docfile != null &&
              _ctx.delegate.docfile.url4Show != null &&
              _ctx.delegate.docfile.url4Show != ''
            )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed",
                    disabled: _ctx.btnDisable,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal4Receipt()))
                  }, _cache[37] || (_cache[37] = [
                    _createElementVNode("span", { class: "fal fa-file-invoice-dollar mr-1" }, null, -1),
                    _createTextVNode("領収書 ")
                  ]), 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-warning waves-effect waves-themed",
                    disabled: _ctx.btnDisable,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal4Receipt()))
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("span", { class: "fal fa-file-invoice-dollar mr-1" }, null, -1),
                    _createTextVNode("領収書未登録 ")
                  ]), 8, _hoisted_12))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.delegate.request.c_request_status != 2 && _ctx.isShowExportBtn())
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed keihiseisansyoExDl",
              disabled: _ctx.btnDisable,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dl()))
            }, _cache[39] || (_cache[39] = [
              _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
              _createTextVNode("Excel出力 ")
            ]), 8, _hoisted_13))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode && _ctx.delegate.request.c_request_status == null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.add()))
            }, _cache[40] || (_cache[40] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("一時保存 ")
            ]), 8, _hoisted_14))
          : _createCommentVNode("", true),
        (
            ((!_ctx.isEditMode && _ctx.isMine) ||
              _ctx.isAdmin ||
              (_ctx.isRewriteMisinsei &&
                _ctx.isLoginUserApproval &&
                _ctx.isLoginUserSettingApprovalUser) ||
              (_ctx.isRewriteMisinsei &&
                _ctx.isMine &&
                !_ctx.isLoginUserSettingApprovalUser)) &&
            (_ctx.delegate.request.c_request_status == 0 ||
              _ctx.delegate.request.c_request_status == 5)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.approvalRequest()))
            }, _cache[41] || (_cache[41] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("承認申請 ")
            ]), 8, _hoisted_15))
          : _createCommentVNode("", true),
        (
            !_ctx.isEditMode &&
            (_ctx.delegate.request.c_request_status == 0 ||
              _ctx.delegate.request.c_request_status == 2 ||
              _ctx.delegate.request.c_request_status == 5)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updNormal(false))),
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed"
            }, _cache[42] || (_cache[42] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_16))
          : _createCommentVNode("", true),
        (
            (_ctx.isEditMode &&
              !_ctx.isRewriteMisinsei &&
              _ctx.isMine &&
              _ctx.delegate.request.c_request_status != 4) ||
            (_ctx.isMine && _ctx.delegate.request.c_request_status == 2)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disableConf()))
            }, _cache[43] || (_cache[43] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("取下 ")
            ]), 8, _hoisted_17))
          : _createCommentVNode("", true),
        (
            (_ctx.isEditMode && _ctx.isAdmin) ||
            (_ctx.isMine &&
              _ctx.delegate.request.c_request_status == 0 &&
              !_ctx.isRewriteMisinsei) ||
            (_ctx.isMine &&
              _ctx.delegate.request.c_request_status == 5 &&
              _ctx.isRewriteMisinsei &&
              !_ctx.isLoginUserSettingApprovalUser) ||
            (!_ctx.isMine &&
              _ctx.delegate.request.c_request_status == 5 &&
              _ctx.isRewriteMisinsei &&
              _ctx.isLoginUserApproval)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.delConf()))
            }, _cache[44] || (_cache[44] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_18))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/shinseisyolist')))
        }, _cache[45] || (_cache[45] = [
          _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
          _createTextVNode("戻る ")
        ]), 8, _hoisted_19)
      ])
    ]),
    _cache[113] || (_cache[113] = _createElementVNode("div", { class: "lockHeaderSpacer" }, "　", -1)),
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
              _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                _createElementVNode("i", { class: "fal fa-info-circle" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1)),
                _cache[50] || (_cache[50] = _createElementVNode("p", null, " この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。 ", -1)),
                _createElementVNode("p", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, _cache[46] || (_cache[46] = [
                    _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                    _createTextVNode("承認 ")
                  ])),
                  _cache[48] || (_cache[48] = _createElementVNode("span", { style: {"width":"20px"} }, " 　", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, _cache[47] || (_cache[47] = [
                    _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
                    _createTextVNode("差戻 ")
                  ]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[52] || (_cache[52] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-3385f0ee><div class=\"mr-2 hidden-md-down\" data-v-3385f0ee><span class=\"icon-stack icon-stack-lg\" data-v-3385f0ee><i class=\"fal fa-info-circle\" data-v-3385f0ee></i></span></div><div class=\"d-flex flex-fill\" data-v-3385f0ee><div class=\"flex-fill\" data-v-3385f0ee><span class=\"h5\" data-v-3385f0ee>この申請書は承認依頼中です</span><p data-v-3385f0ee> この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowSasimodosi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[53] || (_cache[53] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-3385f0ee><div class=\"mr-2 hidden-md-down\" data-v-3385f0ee><span class=\"icon-stack icon-stack-lg\" data-v-3385f0ee><i class=\"fal fa-info-circle\" data-v-3385f0ee></i></span></div><div class=\"d-flex flex-fill\" data-v-3385f0ee><div class=\"flex-fill\" data-v-3385f0ee><span class=\"h5\" data-v-3385f0ee>この申請書は差し戻しされました</span><p data-v-3385f0ee> この申請書は承認権者により差し戻しされています。差し戻し理由を確認の上、この申請書を修正して、再度承認申請を出してください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowTorisage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[54] || (_cache[54] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-3385f0ee><div class=\"mr-2 hidden-md-down\" data-v-3385f0ee><span class=\"icon-stack icon-stack-lg\" data-v-3385f0ee><i class=\"fal fa-info-circle\" data-v-3385f0ee></i></span></div><div class=\"d-flex flex-fill\" data-v-3385f0ee><div class=\"flex-fill\" data-v-3385f0ee><span class=\"h5\" data-v-3385f0ee>この申請書は取り下げられました</span><p data-v-3385f0ee> この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _cache[95] || (_cache[95] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "申請時用"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_31, [
            _cache[94] || (_cache[94] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate.request.c_request_id) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.request.c_request_id]
                      ])
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "管理名", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "xxxx案件でyyyy作業の為",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.request.c_request_name) = $event))
                      }, null, 8, _hoisted_41), [
                        [_vModelText, _ctx.delegate.request.c_request_name]
                      ])
                    ]),
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請日時", -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.convDateTime(_ctx.delegate.request.c_request_datetime)
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_46)
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1)),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      (_ctx.isAdmin && !_ctx.isEditMode)
                        ? (_openBlock(), _createBlock(_component_vSelect, {
                            key: 0,
                            options: _ctx.getOpStaffs(),
                            label: "c_staff_name",
                            modelValue: _ctx.delegate.request.c_staff_id,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate.request.c_staff_id) = $event)),
                            reduce: (label) => label.c_staff_id
                          }, null, 8, ["options", "modelValue", "reduce"]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            name: "txtKouzaCd",
                            class: "form-control form-control-sm",
                            disabled: "",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.domApplicantName) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.domApplicantName]
                          ])
                    ]),
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[69] || (_cache[69] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "起案日", -1)),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domStartDate) = $event))
                      }, null, 8, _hoisted_55), [
                        [_vModelText, _ctx.domStartDate]
                      ]),
                      (_ctx.errors?.path === 'startDate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[68] || (_cache[68] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[74] || (_cache[74] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "仮払金", -1)),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_Mo_CurrencyInput, {
                        modelValue: _ctx.domTmppay_price,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.domTmppay_price) = $event)),
                        class: "form-control form-control-sm",
                        style: {"text-align":"right"},
                        "decimal-places": 0,
                        "allow-negative": false,
                        showValue: true,
                        disabled: _ctx.isEditMode
                      }, null, 8, ["modelValue", "disabled"]),
                      _cache[71] || (_cache[71] = _createElementVNode("span", null, null, -1)),
                      (_ctx.errors?.path === 'tmppayPrice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["icon-stack icon-stack-lg", {
                          notZeroTmppay:
                            _ctx.domTmppay_price != null && _ctx.domTmppay_price > 0,
                        }]),
                        style: {"display":"none","color":"red","font-size":"12px"}
                      }, _cache[70] || (_cache[70] = [
                        _createElementVNode("i", {
                          class: "fal fa-info-circle",
                          style: {"font-size":"16px","margin-right":"5px"}
                        }, null, -1),
                        _createTextVNode("仮払金に間違いないかご確認ください ")
                      ]), 2)
                    ]),
                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[73] || (_cache[73] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _cache[76] || (_cache[76] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第一承認", -1)),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(1),
                        disabled: ""
                      }, null, 8, _hoisted_66)
                    ]),
                    _cache[75] || (_cache[75] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_1_approval,
                            _ctx.delegate.request.c_request_1_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_68)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[78] || (_cache[78] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第二承認", -1)),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(2),
                        disabled: ""
                      }, null, 8, _hoisted_73)
                    ]),
                    _cache[77] || (_cache[77] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_2_approval,
                            _ctx.delegate.request.c_request_2_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_75)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _cache[80] || (_cache[80] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "最終承認", -1)),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(3),
                        disabled: ""
                      }, null, 8, _hoisted_80)
                    ]),
                    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_3_approval,
                            _ctx.delegate.request.c_request_3_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_82)
                    ])
                  ])
                ])
              ]),
              _cache[92] || (_cache[92] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-lg-6 contCnt" }, [
                  _createElementVNode("table", { class: "tb_list" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "tb_title",
                        colspan: "2",
                        rowspan: "8",
                        "x:str": ""
                      }, " 区分 "),
                      _createElementVNode("td", {
                        "x:num": "1",
                        class: "tb_num"
                      }, "1"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "旅費交通費"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 公共交通機関の利用費・駐車場代・宿泊費など。 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "2",
                        class: "tb_num"
                      }, "2"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "交際費"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, [
                        _createTextVNode(" 酒類をともなう飲食代。"),
                        _createElementVNode("span", { style: {"color":"#a92828","font-weight":"bold"} }, "一人あたり"),
                        _createTextVNode("飲食代（税抜5,000円超）、贈答品など。 ")
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "3",
                        class: "tb_num"
                      }, "3"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "会議費"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, [
                        _createTextVNode(" 喫茶代。"),
                        _createElementVNode("span", { style: {"color":"#a92828","font-weight":"bold"} }, "一人あたり"),
                        _createTextVNode("飲食代（税抜5,000円以下） ")
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "4",
                        class: "tb_num"
                      }, "4"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "通信費"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 電話代・通信料・郵便代・切手・葉書代・宅配業者、バイク便など。 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "5",
                        class: "tb_num"
                      }, "5"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "租税公課"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 収入印紙代、証紙代 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "6",
                        class: "tb_num"
                      }, "6"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "消耗品費"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 備品・事務用品・ガソリン代など。 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "7",
                        class: "tb_num"
                      }, "7"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "原価算入"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 売上に関する仕入など。 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        "x:num": "8",
                        class: "tb_num"
                      }, "8"),
                      _createElementVNode("td", {
                        colspan: "3",
                        "x:str": "",
                        class: "tb_name"
                      }, "その他"),
                      _createElementVNode("td", {
                        colspan: "13",
                        "x:str": "",
                        class: "tb_det"
                      }, " 上記にあてはまらいないもの。 ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "col-lg-6 contCnt" }, [
                  _createElementVNode("table", { class: "tb_list" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "tb_title",
                        colspan: "2",
                        rowspan: "8",
                        "x:str": ""
                      }, " インボイス "),
                      _createElementVNode("td", {
                        colspan: "2",
                        "x:str": "",
                        class: "tb_name"
                      }, "T"),
                      _createElementVNode("td", {
                        colspan: "14",
                        "x:str": "",
                        class: "tb_det"
                      }, " 登録番号あり。（法人番号を取得しているからと言って、登録番号申請をしているとは限りません。 個人経営店などは、個人名で番号取得している可能性があり、事後のネット検索は不可能です） ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: "2",
                        "x:str": "",
                        class: "tb_name"
                      }, "特例"),
                      _createElementVNode("td", {
                        colspan: "14",
                        "x:str": "",
                        class: "tb_det"
                      }, " 3万円未満の少額取引、電車代、出張費など。（ただし、一枚領収書で3万円以上は登録番号が必要） ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: "2",
                        "x:str": "",
                        class: "tb_name"
                      }, "なし"),
                      _createElementVNode("td", {
                        colspan: "14",
                        "x:str": "",
                        class: "tb_det"
                      }, " 登録番号を未取得もしくは、不明。 ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: "2",
                        "x:str": "",
                        class: "tb_name"
                      }, "８％"),
                      _createElementVNode("td", {
                        colspan: "14",
                        "x:str": "",
                        class: "tb_det"
                      }, " 軽減税率８％の購入。（持ち帰り軽食、飲料、新聞代など） ")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: "2",
                        "x:str": "",
                        class: "tb_name"
                      }, "０％"),
                      _createElementVNode("td", {
                        colspan: "14",
                        "x:str": "",
                        class: "tb_det"
                      }, " 証紙代、印紙代、保険料。もしくは、参加費、会費で消費税明記がない場合。海外での精算。 ")
                    ])
                  ])
                ])
              ], -1)),
              _cache[93] || (_cache[93] = _createElementVNode("div", { class: "row justify-content-between" }, [
                _createElementVNode("div", {
                  class: "col-auto contTitle",
                  style: {"text-align":"left"}
                }, " 【課税対象】 "),
                _createElementVNode("div", {
                  class: "col-auto contTitle",
                  style: {"text-align":"right"}
                }, " （単位：円／税込） ")
              ], -1)),
              _createElementVNode("div", _hoisted_83, [
                _cache[83] || (_cache[83] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "国税庁リンク", -1)),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "13桁半角数字で登録番号を入力してください",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.domRegistNum) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.domRegistNum]
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed",
                      style: {"height":"30px"},
                      disabled: _ctx.btnDisable,
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToTaxSite()))
                    }, " 検索 ", 8, _hoisted_87),
                    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[82] || (_cache[82] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("table", {
                      class: _normalizeClass(["table table-sm table-bordered m-0 tableKeihi", {
                        isEdit: _ctx.isEditMode,
                      }]),
                      style: {"min-width":"1200px"}
                    }, [
                      _createElementVNode("thead", _hoisted_91, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", {
                            id: "sort4DateHead",
                            class: "fixhead headKeihi cwK_1",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sortRow4Date()))
                          }, _cache[84] || (_cache[84] = [
                            _createTextVNode(" 使用月日 "),
                            _createElementVNode("i", {
                              id: "sort4DateUp",
                              class: "fal fa-sort-amount-up dispNone"
                            }, null, -1),
                            _createElementVNode("i", {
                              id: "sort4DateDown",
                              class: "fal fa-sort-amount-down"
                            }, null, -1)
                          ])),
                          _cache[86] || (_cache[86] = _createElementVNode("th", { class: "fixhead headKeihi cwK_2" }, "区分", -1)),
                          _cache[87] || (_cache[87] = _createElementVNode("th", { class: "fixhead headKeihi cwK_3" }, "支払先", -1)),
                          _cache[88] || (_cache[88] = _createElementVNode("th", { class: "fixhead headKeihi cwK_4" }, "目的", -1)),
                          _cache[89] || (_cache[89] = _createElementVNode("th", { class: "fixhead headKeihi cwK_5" }, "人数", -1)),
                          _cache[90] || (_cache[90] = _createElementVNode("th", { class: "fixhead headKeihi cwK_6" }, "金額/税込", -1)),
                          _createElementVNode("th", {
                            id: "sort4InvoiceHead",
                            class: "fixhead headKeihi cwK_7",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sortRow4invoice()))
                          }, _cache[85] || (_cache[85] = [
                            _createTextVNode(" インボイス "),
                            _createElementVNode("i", {
                              id: "sort4InvoiceUp",
                              class: "fal fa-sort-amount-up dispNone"
                            }, null, -1),
                            _createElementVNode("i", {
                              id: "sort4InvoiceDown",
                              class: "fal fa-sort-amount-down"
                            }, null, -1)
                          ]))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expensesList, (item) => {
                          return (_openBlock(), _createBlock(_component_Mo_expenses_row, {
                            key: item.c_expenses_rownum!,
                            item: item,
                            isDisable: _ctx.isDisableExpensesList,
                            class: "tb_input",
                            onReCalc: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sumCalc()))
                          }, null, 8, ["item", "isDisable"]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _cache[91] || (_cache[91] = _createElementVNode("th", {
                            colspan: "5",
                            class: "bg-primary-400",
                            style: {"text-align":"center"}
                          }, " 合計金額（税込） ", -1)),
                          _createElementVNode("td", _hoisted_92, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "50",
                              style: {"text-align":"right"},
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.domSumPrice) = $event)),
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, _ctx.domSumPrice]
                            ])
                          ])
                        ])
                      ])
                    ], 2)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_right_l, { ref: "Mo_modal_receipt" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_93, [
          _cache[98] || (_cache[98] = _createTextVNode(" 領収書 ")),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", {
              type: "button",
              id: "btnOpenRecept",
              class: "btn-sm btn-primary waves-effect waves-themed",
              disabled: 
                _ctx.btnDisable ||
                _ctx.delegate.docfile == null ||
                _ctx.delegate.docfile.url4Show == null ||
                _ctx.delegate.docfile.url4Show == ''
              ,
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openRecept()))
            }, _cache[96] || (_cache[96] = [
              _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
              _createTextVNode("ダウンロード ")
            ]), 8, _hoisted_95),
            _createElementVNode("button", {
              type: "button",
              id: "btnOpenRecept",
              class: "btn-sm btn-primary waves-effect waves-themed",
              style: {"margin-left":"10px"},
              disabled: 
                _ctx.btnDisable ||
                _ctx.delegate.docfile == null ||
                _ctx.delegate.request.c_request_status != 3
              ,
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.goTo('/docedit?id=' + _ctx.delegate.docfile.c_doc_id, $event)))
            }, _cache[97] || (_cache[97] = [
              _createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1),
              _createTextVNode("文書詳細 ")
            ]), 8, _hoisted_96)
          ])
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_97, [
          _cache[100] || (_cache[100] = _createElementVNode("div", { class: "loader" }, [
            _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
          ], -1)),
          (
              (_ctx.isEditMode && _ctx.isAdmin) ||
              (_ctx.isMine && !_ctx.isRewriteMisinsei) ||
              (_ctx.isMine &&
                _ctx.isRewriteMisinsei &&
                !_ctx.isLoginUserSettingApprovalUser) ||
              (!_ctx.isMine && _ctx.isRewriteMisinsei && _ctx.isLoginUserApproval)
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _createVNode(_component_dropzone, {
                  fileInfo: _ctx.fileInfo,
                  updateFileInfo: _ctx.updateFileInfo,
                  isMinMode: true
                }, null, 8, ["fileInfo", "updateFileInfo"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_99, " 領収書のアップロードは、自身の経費精算書でのみ可能です。 ")),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              (
                  _ctx.delegate.docfile != null &&
                  _ctx.delegate.docfile.url4Show != null &&
                  _ctx.delegate.docfile.url4Show != '' &&
                  _ctx.showReceptImg
                )
                ? (_openBlock(), _createBlock(_component_Or_pdfviewer, {
                    key: 0,
                    item: _ctx.delegate.docfile
                  }, null, 8, ["item"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _createElementVNode("div", null, [
                      (
                        _ctx.delegate.docfile != null &&
                        _ctx.delegate.docfile.url4Show != null &&
                        _ctx.delegate.docfile.url4Show != ''
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, " 画像読み込み中・・・ "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_104, " 領収書が登録されていません ")),
                      _cache[99] || (_cache[99] = _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: "/img/backgrounds/imgloading.svg",
                          alt: "",
                          style: {"width":"100%"}
                        })
                      ], -1))
                    ])
                  ]))
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_105, [
          _createElementVNode("button", {
            disabled: _ctx.btnDisable,
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal4Receipt()))
          }, _cache[101] || (_cache[101] = [
            _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
            _createTextVNode("閉じる ")
          ]), 8, _hoisted_106)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[27] || (_cache[27] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[102] || (_cache[102] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[103] || (_cache[103] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[104] || (_cache[104] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_rewiteConf" }, {
      title: _withCtx(() => [
        _cache[105] || (_cache[105] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalRewriteConf), 1)
      ]),
      body: _withCtx(() => _cache[106] || (_cache[106] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("button", {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.rewrite())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.closeModal4RewriteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[107] || (_cache[107] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[108] || (_cache[108] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("button", {
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_disableConf" }, {
      title: _withCtx(() => [
        _cache[109] || (_cache[109] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDisableConf), 1)
      ]),
      body: _withCtx(() => _cache[110] || (_cache[110] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("button", {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.disab())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.closeModal4disableConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[111] || (_cache[111] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[112] || (_cache[112] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("button", {
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}